import { FILTER_FIELD_TYPE } from '../../utils/DataConstants';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const DEFAULT_SORT_BY = { sort_by: 'name', order: 'ascend' };

const defaultValueAccessor = (config) => (entity) => {
	switch (config.type) {
		case FILTER_FIELD_TYPE.DATE_RANGE:
			return entity;
		case FILTER_FIELD_TYPE.OW_MULTI_SELECT:
		case FILTER_FIELD_TYPE.RADIO_GROUP:
			return entity.value;
		case FILTER_FIELD_TYPE.TUPLE:
		default:
			return entity.id;
	}
};

const defaultRenderItem = (config) => (entity) => {
	switch (config.type) {
		case FILTER_FIELD_TYPE.DATE_RANGE:
			return entity;
		case FILTER_FIELD_TYPE.OW_MULTI_SELECT:
		case FILTER_FIELD_TYPE.RADIO_GROUP:
			return entity.label;
		case FILTER_FIELD_TYPE.TUPLE:
		default:
			return entity.name;
	}
};

/**
 * Adapts a filter config for the standalone locations-map toolbar's
 * <AdvancedFilters>, which renders outside <ReduxDataTable>. The essential bit
 * is resolving each filter's value from `${targetCollectionName}.filters` inside
 * the redux slice — ReduxDataTable normally does this, and without it the filter
 * selects read the wrong path and never reflect the active selection. The
 * render/accessor defaults mirror the same fallbacks the filter components rely
 * on. `handleChange`/`component` are already supplied by the location filter
 * config and pass through via the spread.
 */
export const buildToolbarFilterConfig = (filterConfig: any[], targetCollectionName: string) =>
	filterConfig.map((config) => ({
		...config,
		keyAccessor: config.keyAccessor || config.valueAccessor || defaultValueAccessor(config),
		valueAccessor: config.valueAccessor || defaultValueAccessor(config),
		renderItem: config.renderItem || defaultRenderItem(config),
		labelAccessor: config.labelAccessor || config.renderItem || defaultRenderItem(config),
		renderRecord: config.renderRecord || config.renderItem || defaultRenderItem(config),
		sortBy: config.sortBy || DEFAULT_SORT_BY,
		filtersValueAccessor: config.filtersValueAccessor
			? (ss, option) =>
					config.filtersValueAccessor(
						nullSafeGetOrElse(`${targetCollectionName}.filters`, ss, {}),
						option
					)
			: (ss) => nullSafeGet(`${targetCollectionName}.filters.${config.fieldName}`, ss),
	}));
